<template>
  <v-card
    class="step-card"
    :class="{
      'step-card--complete': !condition,
      'step-card--next': isNextOpen && condition,
    }"
    outlined
    hover
    ripple
    @click="redirectToPath"
  >
    <v-card-text class="step-card__body pa-4">
      <div class="step-card__meta">
        <span class="step-card__number">{{ hintNumber }}</span>
        <v-chip
          x-small
          label
          class="step-card__status"
          :color="condition ? 'primary' : 'success'"
          text-color="white"
        >
          {{ condition ? $t('overview.step_pending') : $t('overview.step_done') }}
        </v-chip>
      </div>
      <div class="step-card__icon-wrap">
        <v-icon :color="condition ? 'primary' : 'success'" size="44">{{ icon }}</v-icon>
      </div>
      <div class="step-card__text">{{ text }}</div>
      <div class="step-card__cta text-caption primary--text">
        <span>{{ $t('overview.step_open') }}</span>
        <v-icon x-small color="primary" class="ml-1">mdi-arrow-right</v-icon>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TodoListItem',
  props: {
    text: {
      type: String,
      required: true,
    },
    redirectPath: {
      type: String,
      required: true,
    },
    hintNumber: {
      type: String,
      required: true,
    },
    condition: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: 'mdi-checkbox-blank-circle-outline',
    },
    isNextOpen: {
      type: Boolean,
      default: false,
    },
    /** When set, navigate with query string (e.g. { 'add-validation-images': '1' }). */
    redirectQuery: {
      type: Object,
      default: null,
    },
  },
  methods: {
    redirectToPath() {
      if (
        this.redirectQuery
        && typeof this.redirectQuery === 'object'
        && Object.keys(this.redirectQuery).length > 0
      ) {
        this.$router.push({ path: this.redirectPath, query: this.redirectQuery });
      } else {
        this.$router.push(this.redirectPath);
      }
    },
  },
};
</script>

<style scoped>
.step-card {
  height: 100%;
  cursor: pointer;
  border-radius: 10px;
  transition: box-shadow 0.2s ease, transform 0.15s ease;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.step-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
}

.step-card--complete {
  background: linear-gradient(
    180deg,
    rgba(76, 175, 80, 0.06) 0%,
    transparent 48%
  ) !important;
}

.step-card--next {
  background: linear-gradient(
    180deg,
    rgba(25, 118, 210, 0.08) 0%,
    transparent 48%
  ) !important;
}

.theme--dark .step-card--next {
  background: linear-gradient(
    180deg,
    rgba(100, 181, 246, 0.12) 0%,
    transparent 48%
  ) !important;
}

.step-card__body {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: center;
  min-height: 200px;
}

.step-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}

.step-card__number {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.45);
  text-transform: uppercase;
}

.theme--dark .step-card__number {
  color: rgba(255, 255, 255, 0.5);
}

.step-card__status {
  font-weight: 600;
}

.step-card__icon-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0 12px;
  min-height: 52px;
}

.step-card__text {
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.87);
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme--dark .step-card__text {
  color: rgba(255, 255, 255, 0.92);
}

.step-card__cta {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  opacity: 0.85;
}
</style>
